import React from "react";
import ProductList from "../components/ProductList";

const subCategoryList = [
  { id: 1, name: "Accessories" }
];

const productList = [
    { id:1 , name: "Office Stationery"	, image: "/images/book.jpg", description: "Tools.", category: "Office Stationery", subCategoryId: 0 },
    { id:2 , name: "Industrial Paint"    , image: "/images/Industrial Paint.jpg", description: "Tools.", category: "Paint", subCategoryId: 0 },
    { id:3 , name: "Marine Paint"        , image: "/images/marine-paint-system.png", description: "Tools.", category: "Paint", subCategoryId: 0 },
    { id:4 , name: "Epoxy & Coating"     , image: "/images/Epoxy & Coating.png", description: "Tools.", category: "Paint", subCategoryId: 0 },
    { id:5 , name: "E- House"	        , image: "/images/e-house.jpg", description: "Tools.", category: "E-House", subCategoryId: 0 },
    { id:6 , name: "Adhesive & sealant"  , image: "/images/mens-hand-uses-silicone-adhesive.jpg", description: "Tools.", category: "Consumable", subCategoryId: 0 },
    { id:7 , name: "Distilled water"     , image: "/images/Distilledwater.jpg", description: "Tools.", category: "Consumable", subCategoryId: 0 },
    { id:8 , name: "Lubricant & Grease"  , image: "/images/Lubricant & Grease.jfif", description: "Tools.", category: "Consumable", subCategoryId: 0 },
];

const GeneralCategory: React.FC = () => {
  return <ProductList title="General Category Products" products={productList} subCategories={subCategoryList} categoryName="General Category"/>;
};

export default GeneralCategory;
